var render = function render(){var _vm=this,_c=_vm._self._c;return _c('glass-panel',{staticClass:"glass-data-table-panel",attrs:{"radius":"lg"}},[_c('v-data-table',_vm._g(_vm._b({scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,slotName){return {key:slotName,fn:function(slotProps){return [_vm._t(slotName,null,null,slotProps)]}}})],null,true)},'v-data-table',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }